import React from "react";
import { InlineMarkerButton } from "./InlineMarkerButton";

/**
 * 처방전 지칭 버튼 — 시각 규격 V2(spec 설계 결정 13). HospitalButton과 공통 기반
 * `InlineMarkerButton`을 공유한다. atoms/Button 미사용.
 *
 * 본문의 `처방전N` 텍스트를 클릭 버튼으로 만들어 좌측의 해당 그룹 하나를 하이라이트한다.
 * 텍스트 자체가 식별자라 TipTap 노드·data 속성이 불필요하다(편집 왕복 무손실 — 평문화돼도 재버튼화).
 *
 * - `onPrescriptionClick` 없으면(인쇄·임베드) 평문 텍스트 — 밑줄·색 없음.
 * - "선택됨" 시각 표시는 본문에 두지 않는다(spec 설계 결정 13). 선택 상태는 좌측 처방 패널에만 남는다.
 */
export interface PrescriptionButtonProps {
  n: number;
  onPrescriptionClick?: (n: number) => void;
}

const PrescriptionButton: React.FC<PrescriptionButtonProps> = ({
  n,
  onPrescriptionClick,
}) => {
  const label = `처방전${n}`;

  if (!onPrescriptionClick) {
    return <>{label}</>;
  }

  return (
    <InlineMarkerButton
      type="button"
      onClick={() => onPrescriptionClick(n)}
      title={label}
    >
      {label}
    </InlineMarkerButton>
  );
};

export default PrescriptionButton;
